var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default",null,{"user":_vm.user,"participants":_vm.participants,"mainScreenParticipant":_vm.mainScreenParticipant,"handleHangUp":_vm.handleHangUp,"handleChangeMainScreen":_vm.handleChangeMainScreen})],2)}
var staticRenderFns = []

export { render, staticRenderFns }